import { isShitScheduledToday, isShitDone, doShitRepeats, isShitTrashed, isShitEmpty } from '../constants/shit-functions'

// any shit specific shit should be here
export default {
  computed: {
    isShitScheduledToday () {
      return isShitScheduledToday(this.shit)
    },
    isDone () {
      return isShitDone(this.shit)
    },
    isMit () {
      return this.isShitMit(this.shit)
    },
    isBigRock () {
      return this.isShitBigRock(this.shit)
    },
    isTrashed () {
      return isShitTrashed(this.shit)
    },
    isEmpty () {
      return isShitEmpty(this.shit)
    },
    repeats () {
      return doShitRepeats(this.shit)
    }
  },
  methods: {
    isShitBigRock (shit) {
      return this.$store.state.bigRocks.indexOf(shit.uuid) !== -1
    },
    isShitMit (shit) {
      return this.$store.state.mits.indexOf(shit.uuid) !== -1
    }
  }
}
